import { reactive } from "vue";

export default reactive({
  account: {},
    //api_root: "http://localhost:4000",
    api_root: "https://api.staging.ruebarue.com/beta"
});
